import { FC, ReactElement, SVGProps } from 'react'

type PictogramSize = 'super-extra-small' | 'extra-small' | 'small' | 'medium' | 'large' | number

export type PictogramProps = {
    size?: PictogramSize
    className?: string
}

const sizeInPx = (size: PictogramSize): number => {
    if (typeof size === 'number') {
        return size
    }

    switch (size) {
        case 'super-extra-small':
            return 24
        case 'extra-small':
            return 32
        case 'small':
            return 40
        case 'medium':
            return 56
        case 'large':
            return 80
    }
}

/**
 * Create a Pictogram component with a specific SVG
 * For use only within the DS—do not export out of the DS
 */
export default function createPictogram(
    PictogramComponent: FC<SVGProps<unknown>>
): (props: PictogramProps) => ReactElement<PictogramProps> {
    return function PictogramCreator({ size = 'large', className }: PictogramProps): ReactElement<PictogramProps> {
        const pixels = sizeInPx(size)

        // Viewbox needs to be set to ensure proper scaling and matches the coordinate space of
        // the image, so it's always 80x80px, regardless of the size we want to scale to.
        //
        // More info:  https://css-tricks.com/scale-svg/
        return <PictogramComponent viewBox="0 0 80 80" width={pixels} height={pixels} className={className} />
    }
}

export type PictogramType = ReturnType<typeof createPictogram>
